import { generatedId } from './helper';

export const kanbanBoardCols = [
  {
    title: 'To Do',
    id: generatedId(),
    issues: [],
  },
  {
    title: 'In Progress',
    id: generatedId(),
    issues: [],
  },
  {
    title: 'Done',
    id: generatedId(),
    issues: [],
  },
];
